import { Card04LineClamp } from './components/card04/_lineClamp';
import { CardLargeLineClamp } from './components/cardLarge/_lineClamp';
import { CardMiddleLineClamp } from './components/cardMiddle/_lineClamp';
import { CardSmallLineClamp } from './components/cardSmall/_lineClamp';
import { CustomLinkManager } from './components/customLink/_customLink';
import { DetailCloseManager } from './components/detailClose/_detailClose';
import { DetailAnimationManager } from './components/detailsAnimation/_detailsAnimation';
import { Device } from './components/device/_device';
import HorizontalScroll from './components/horizontalScroll/_horizontalScroll';
import { ImageMapManager } from './components/imageMap/_imageMapManager';
import Lightbox from './components/lightbox/_lightbox';
import { Modal } from './components/modal/_modal';
import { OpenCloseManager } from './components/openClose/_openClose';
import { PageTopLinkManager } from './components/pageTop/_pageTop';
import ProductsNavHeight from './components/projuctsNavItem/_productsNavHeight';
import ProductsNavToggleSp from './components/projuctsNavItem/_productsNavToggleSp';
import ProductsNavTooltip from './components/projuctsNavItem/_productsNavTooltip';
import { ProjuctsNavItemToggleManager } from './components/projuctsNavItem/_projuctsNavItem';
import { ProductsNavSp } from './components/projuctsNavItem/_projuctsNavSp';
import { RandomViewManager } from './components/randomView/_randomView';
import { SearchModal } from './components/serchModal/_serchModal';
import { SetHeightManager } from './components/setHeight/_setHeight';
import Slider from './components/slider/_slider';
import StoryKV from './components/storyKeyVisual/_storyKeyVisual';
import { TabsManager } from './components/tabsManager/_tabsManager';
import { ToggleManager } from './components/toggle/_toggle';
import WidthWrapper from './components/widthWrapper/_widthWrapper';
import { WindowSizeManager } from './components/windowWight/_windowWight';
import { BrowserDetector } from './components/browser/_browser';
import { StickyContentManagerGroup } from './components/titleStickyContent/_titleStickyContent';

// デバイス
const device = new Device();

// ブラウザ判定
BrowserDetector.detect();

// randomView
const randomView = new RandomViewManager();

/**
 * DOMContentLoaded とは
 * ページの読み込みが完了した時に発生するイベント
 * このイベントが発生した時に初期化処理を行う
 */
document.addEventListener('DOMContentLoaded', () => {
  // 読み込み完了したら htmlタグに ist-loaded クラスを追加
  document.documentElement.classList.add('ist-loaded');

  // ウィンドウサイズを管理するマネージャークラス
  const windowManager = new WindowSizeManager();

  // widthWrapper
  const widthWrapper = new WidthWrapper();

  // storyKeyVisual
  const storyKeyVisual = new StoryKV();

  // cardSmall テキストの行数を制限
  const cardSmallLineClamp = new CardSmallLineClamp({ debug: false });

  // searchModal
  const searchModal = new SearchModal();

  // customLink
  const customLink = new CustomLinkManager();

  // cardMiddle テキストの行数を制限
  const cardMiddleLineClamp = new CardMiddleLineClamp({ debug: true });

  // card04 テキストの行数を制限
  const card04LineClamp = new Card04LineClamp({ debug: false });

  // cardLarge テキストの行数を制限
  const cardLargeLineClamp = new CardLargeLineClamp({ debug: false });

  // toggle
  const toggleManager = new ToggleManager();

  // lightbox
  const lightbox = new Lightbox('.ist-js__lightbox');

  // slider
  const slider = new Slider('.ist-slider .splide');

  // horizontalScroll
  const horizontalScroll = new HorizontalScroll();

  // tab
  const tabManager = new TabsManager();

  // setHeight
  const setHeight = new SetHeightManager();

  // projuctsNavHeight
  const projuctsNavHeight = new ProductsNavHeight();

  // projuctsNavItem
  const projuctsNavItem = new ProjuctsNavItemToggleManager();

  // projuctsNavTooltip
  const projuctsNavTooltip = new ProductsNavTooltip();

  // projuctsNavSp
  const navSp = new ProductsNavSp();

  // projuctsNavToggleSp
  const toggleSp = new ProductsNavToggleSp();

  // ProductsNavSp からフォーカスマネージャインスタンスを取得し、ToggleSp にセット
  toggleSp.setNavFocusManagers(navSp.getFocusManagers());

  // pageTop
  const pageTop = new PageTopLinkManager();

  // imageMap
  const imageMap = new ImageMapManager({ enabled: false });

  // modal
  const modal = new Modal();

  // detailClose
  const detailClose = new DetailCloseManager();

  // detailAnimation
  const animationManager = DetailAnimationManager.getInstance();
  const closeManager = new DetailCloseManager();

  // openClose
  const openClose = new OpenCloseManager();

  // StickyContent
  const stickyContent = new StickyContentManagerGroup(true);
});
